













































































































































































































































































































































































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import BankInOverViewDTO from "../models/BankInOverViewDTO";
import CheckBox from "@/components/CheckBox.vue";
import cashStatementStore from "@/modules/cashStatement/services/store";
import eventBus from "@/services/eventBus";
import MoneyInput from "@/components/MoneyInput.vue";
import store, { BankStatementStore } from "@/modules/bankStatement/services/BankStatementStore";
import { t } from "@/plugins/i18n";

interface Data {
  filter: FilteringModel;
  sum: number;
  items: BankInOverViewDTO[];
  selectedItems: BankInOverViewDTO[];
  store: BankStatementStore;
}

interface Props {
  extraFilter: FilteringModel;
  partnerId: number;
  currency: string;
  title: string;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
}

interface Methods {
  selected(item: BankInOverViewDTO): void;
  showDetails(item: BankInOverViewDTO): void;
  addToSummary(dataItem: BankInOverViewDTO): void;
  setItems(items: BankInOverViewDTO[]): void;
  generatePaymentItems(): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearchPage, CheckBox, MoneyInput },

  props: {
    extraFilter: { type: Object as () => FilteringModel },
    partnerId: { type: Number, default: 1 },
    currency: { type: String, default: "" },
    title: {
      type: String,
      default: t("Szamlavalogato"),
    },
  },

  data: () => ({
    filter: new FilteringModel(),
    sum: 0,
    items: [],
    selectedItems: [],
    store
  }),

  beforeMount() {
    this.filter = new FilteringModel();
    if (this.$props.extraFilter)
      this.filter = this.filter.fromFilter(this.$props.extraFilter.toObject());
  },

  methods: {
    selected(item: BankInOverViewDTO) {
      this.$emit("selected", item);
    },

    showDetails(item: BankInOverViewDTO) {
      item.selected = !item.selected;
    },

    addToSummary(dataItem: BankInOverViewDTO) {
      // A selectedItems-et azonnal, közvetlenül karbantartjuk: a korábbi
      // get-items eventbus kör csak a KÖVETKEZŐ eseménynél vette fel a most
      // kijelölt tételt, így lapozáskor/szűréskor az utolsó kijelölés elveszett.
      if (!dataItem.added) {
        dataItem.added = true;
        const alreadySelected = this.selectedItems.some(
          (x) => x.invoiceNo === dataItem.invoiceNo && x.prefix === dataItem.prefix
        );
        if (!alreadySelected) {
          this.selectedItems.push(dataItem);
        }
      } else {
        dataItem.added = false;
        this.selectedItems = this.selectedItems.filter(
          (x) => !(x.invoiceNo === dataItem.invoiceNo && x.prefix === dataItem.prefix)
        );
      }

      this.sum = this.selectedItems.reduce(
        (acc, x) => acc + Math.abs(x.amountToAdd),
        0
      );

      let sumToSend = this.sum;
      if (this.store.bankStatement.currency != "HUF"){
        sumToSend = sumToSend / this.store.bankDocument.bankStatementItem.exchangeRate;
      }

      eventBus.$emit("update-sum", sumToSend);
    },

    generatePaymentItems() {
      this.$emit("generate-payments", {
        selectedItems: this.selectedItems,
        partnerID: this.$props.partnerId,
      });

      this.selectedItems = [];
    },

    setItems(items) {
      this.items = items;
      const newSelected = items.filter((x) => x.added);
      newSelected.forEach((element) => {
        const alreadySelected = this.selectedItems.some(
          (x) => x.invoiceNo === element.invoiceNo && x.prefix === element.prefix
        );
        if (!alreadySelected) {
          this.selectedItems.push(element);
        }
      });

      // Lapozás/szűrés után a frissen letöltött sorokon visszajelöljük a
      // korábban kiválasztott tételeket, és a selectedItems-ben a régi
      // objektumot a megjelenített frissre cseréljük; a szerkesztett
      // fizetendő összeget átvisszük a friss sorra.
      this.selectedItems = this.selectedItems.map((element) => {
        const item = items.find(
          (x) => x.invoiceNo === element.invoiceNo && x.prefix === element.prefix
        );
        if (item && item !== element) {
          item.added = true;
          item.amountToAdd = element.amountToAdd;
          return item;
        }
        return element;
      });
    },
  },

  computed: {
    columns: function() {
      return [
            {
              cell: "statementDetailsButtonTemplate",
              filterable: false,
            },
            { field: "prefix", title: t("Prefix") },
            { field: "invoiceNo", title: t("Szamlaszam") },
            { field: "itemNo", title: t("KivonatAzonosito") },
            {
              cell: "amount",
              field: "amount",
              title: t("BankExtract_TenylegesOsszeg"),
              type: ColumnType.Money,
            },
            { field: "currency", title: t("Penznem") },
            {
              cell: "oriAmount",
              field: "oriAmount",
              title: t("BankExtract_TeljOsszTeljP"),
              type: ColumnType.Money,
            },
            { field: "oriCurrency", title: t("BankExtract_TeljesitesPenznem") },
            {
              cell: "amountToAdd",
              field: "amountToAdd",
              title: t("Fizetendo"),
              type: ColumnType.Money,
            },
            { field: "remark", title: t("Megjegyzes") },
            {
              cell: "selectButton",
              filterable: false,
            },
          ];
    },

    url() {
      return `bankout/over/search/${this.$props.partnerId}/${this.$props.currency}`;
    },
  },
});
